export default __webpack_public_path__ + "static/media/room1_main.4362b8f3.jpeg";